import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";

import HistoryList from "./HistoryList";

const AlarmHistoryList = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "报警管理" })} />
      <div className={classes.titleWithSelect}>
        <Typography variant="h4">
          {t({ defaultMessage: "报警管理" })}
        </Typography>
      </div>
      <div className={classes.paperWrapper}>
        <HistoryList />
      </div>
    </>
  );
};

export default AlarmHistoryList;
